import React, { useState } from "react"
import { loadStripe } from "@stripe/stripe-js"
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js"
import { VITE_STRIPE_PUBLIC_KEY } from "env"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify";

const stripePromise = loadStripe(VITE_STRIPE_PUBLIC_KEY)

interface Props {
    clientSecret: string // lấy từ backend trả về (response_stripe.client_secret)
    orderId: number | string
    email: string
}

const CheckoutForm: React.FC<Props> = ({ clientSecret, orderId, email }) => {
    const stripe = useStripe()
    const elements = useElements()
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        setMessage("")
        setLoading(true)

        if (!stripe || !elements) {
            setMessage("Stripe chưa được khởi tạo.")
            setLoading(false)
            return
        }

        const card = elements.getElement(CardElement)
        if (!card) {
            setMessage("Không tìm thấy Card Element.")
            setLoading(false)
            return
        }

        try {
            // 🔹 Gửi lên Stripe để xác nhận thanh toán bằng client_secret
            const result = await stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card,
                    billing_details: { email },
                },
            })

            if (result.error) {
                console.error("Stripe error:", result.error.message)
                setMessage(`Thanh toán thất bại: ${result.error.message}`)
                toast.error("Thanh toán thất bại, vui lòng thử lại");
            } else if (result.paymentIntent?.status === "succeeded") {
                localStorage.removeItem('clientSecret')
                localStorage.removeItem('orderId')
                setMessage("Thanh toán thành công 🎉")
                toast.success("Thanh toán thành công 🎉");
                setTimeout(() => {
                    navigate("/");
                }, 1000);
            }
        } catch (err: any) {
            console.error(err)
            setMessage("Đã xảy ra lỗi không xác định.")
        }

        setLoading(false)
    }

    return (
        <form
            onSubmit={handleSubmit}
            className="w-full mx-auto p-4 rounded-xl bg-white shadow-md flex flex-col gap-4 m-8"
        >
            <label className="font-semibold">Thông tin thẻ thanh toán:</label>
            <div className="p-3 border rounded">
                <CardElement options={{ hidePostalCode: true }} />
            </div>

            <button
                type="submit"
                disabled={!stripe || loading}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
            >
                {loading ? "Đang xử lý..." : "Xác nhận thanh toán"}
            </button>

            {message && <p className="text-center text-sm text-gray-600">{message}</p>}
        </form>
    )
}

const StripePaymentForm: React.FC<Props> = (props) => (
    <Elements stripe={stripePromise}>
        <CheckoutForm {...props} />
    </Elements>
)

export default StripePaymentForm
